import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTextField } from 'src/components/mui-overrides/Textfield';

interface Props {
  disabled?: boolean;
}

export const InvestedToDateField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <DefaultTextField
      disabled={disabled}
      fieldName="investmentDetails.investedToDate"
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.investedToDate')}
      formik={formik}
      type="number"
    />
  );
};
